<template>
  <div>
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
        :z-index="10000000"
        background-color="#000"
        color="#fff"
      ></loading>
    </div>
    <transition name="right">
      <div class="filter text-white" v-if="filterDisplay">
        <div class="filter-header grid grid-cols-3">
          <font-awesome-icon icon="times" class="close" @click="closeFilter" />
          <h2 class="text-white text-center">Filter By</h2>
        </div>
        <div class="filter-input">
          <label>Start Date</label>
          <div class="col-span-4 mb-5">
            <v-date-picker
              class="date-picker w-full"
              is-dark
              v-model="startDate"
              @dayclick="loadFilteredTable"
            >
              <template v-slot="{ inputEvents }">
                <div class="date w-full">
                  <input
                    type="button"
                    class="date-input w-full text-left"
                    v-on="inputEvents"
                    :value="formattedStartDate"
                  />
                </div>
              </template>
            </v-date-picker>
          </div>
          <label>End Date</label>
          <div class="col-span-4 mb-5">
            <v-date-picker
              class="date-picker w-full"
              is-dark
              :min-date="startDate"
              v-model="endDate"
              @dayclick="loadFilteredTable"
            >
              <template v-slot="{ inputEvents }">
                <div class="date w-full">
                  <input
                    type="button"
                    class="date-input w-full text-left"
                    v-on="inputEvents"
                    :value="formattedEndDate"
                  />
                </div>
              </template>
            </v-date-picker>
          </div>
          <label>สถานะ</label>
          <select class="w-full" v-model="status" @change="loadFilteredTable">
            <option :value="null">ALL</option>
            <option v-for="status in statusList" :key="status">{{
              status
            }}</option>
          </select>
          <vs-button
            class="mt-3"
            color="#ffffff"
            text-color="#8d9498"
            @click="resetFilter"
            >รีเซ็ต
          </vs-button>
        </div>
      </div>
    </transition>
    <transition name="right">
      <div class="filter text-white" v-if="exportDisplay">
        <div class="filter-header grid grid-cols-3">
          <font-awesome-icon icon="times" class="close" @click="closeExport" />
          <h2 class="text-white text-center">Export</h2>
        </div>
        <div class="filter-input">
          <label>Start Date</label>
          <div class="col-span-4 mb-5">
            <v-date-picker
              class="date-picker w-full"
              is-dark
              v-model="exportStartDate"
            >
              <template v-slot="{ inputEvents }">
                <div class="date w-full">
                  <input
                    type="button"
                    class="date-input w-full text-left"
                    v-on="inputEvents"
                    :value="formattedExportStartDate"
                  />
                </div>
              </template>
            </v-date-picker>
          </div>
          <label>End Date</label>
          <div class="col-span-4 mb-5">
            <v-date-picker
              class="date-picker w-full"
              is-dark
              :min-date="exportStartDate"
              v-model="exportEndDate"
            >
              <template v-slot="{ inputEvents }">
                <div class="date w-full">
                  <input
                    type="button"
                    class="date-input w-full text-left"
                    v-on="inputEvents"
                    :value="formattedExportEndDate"
                  />
                </div>
              </template>
            </v-date-picker>
          </div>
          <label>สถานะ</label>
          <select class="w-full" v-model="exportStatus">
            <option :value="null">ALL</option>
            <option v-for="status in statusList" :key="status">{{
              status
            }}</option>
          </select>
          <vs-button
            class="mt-3"
            color="#69d8d1"
            style="width: 140px;"
            @click="exportExcel"
          >
            Export
          </vs-button>
        </div>
      </div>
    </transition>
    <base-dialog :show="showDialog" @close="toggleDialog">
      <div class="px-8">
        <h2 class="text-center my-5">
          กรุณาเลือกผู้รับเงิน ชื่อลูกค้า และ Task
        </h2>
        <div class="grid grid-cols-12 gap-y-4 py-4 items-center">
          <h4>ผู้รับเงิน</h4>
          <select
            class="col-span-4"
            style="background-color: #4E5363"
            v-model="selectedAccounting"
            @change="loadFilteredMember"
          >
            <option :value="null">ALL</option>
            <option
              v-for="account in accountingList"
              :key="account.accounting_id"
              :value="account.accounting_id"
              >{{ account.acc_code }}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {{ account.name_th }}
            </option>
          </select>
          <h4 class="col-start-1">ชื่อลูกค้า</h4>
          <select
            class="col-span-4"
            style="background-color: #4E5363"
            @change="setCompany"
            v-model="modalCompany"
          >
            <option
              v-for="member in memberList"
              :key="member.detail_id"
              :value="{ name: member.company_name, id: member.detail_id }"
            >
              {{ member.company_name }}
            </option>
          </select>
          <div
            class="col-start-10 col-span-3 grid grid-cols-4 text-right items-center"
          >
            <h4 class="mr-5">เดือน</h4>
            <select
              style="background-color: #4E5363"
              v-model="monthSelected"
              @change="loadSubTable"
            >
              <option value="0">ALL</option>
              <option v-for="month in monthList" :key="month" :value="month">
                {{ month }}
              </option>
            </select>
            <h4 class="mr-5">ปี</h4>
            <select
              style="background-color: #4E5363"
              v-model="yearSelected"
              @change="loadSubTable"
            >
              <option value="ALL">ALL</option>
              <option v-for="year in yearList" :key="year" :value="year">
                {{ year }}
              </option>
            </select>
          </div>
        </div>
        <ag-table
          ref="invoiceTable"
          style="box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.09);"
        />
        <div class="grid grid-cols-8 gap-4 mt-5">
          <vs-button
            class="col-end-8"
            color="#ffffff"
            style="box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.09);"
            text-color="#8d9498"
            @click="toggleDialog"
          >
            ยกเลิก
          </vs-button>
          <vs-button
            class="col-end-9"
            button="submit"
            color="#15c1c3"
            @click="setSelectedTask"
            >บันทึก</vs-button
          >
        </div>
      </div>
    </base-dialog>
    <base-dialog :show="displayDelete" small>
      <div class="mx-5 my-5">
        <h4 class="text-white">ยืนยันการลบInvoiceนี้</h4>
        <div class="grid grid-cols-12 gap-4 mt-20">
          <vs-button
            class="col-end-9 col-span-4"
            color="#ffffff"
            text-color="#8d9498"
            @click="displayDelete = false"
            >ยกเลิก</vs-button
          >
          <vs-button
            class="col-end-13 col-span-4"
            color="#15c1c3"
            @click="confirmDeleteInvoice"
            >ยืนยัน</vs-button
          >
        </div>
      </div>
    </base-dialog>
    <base-dialog :show="displayDownload" small>
      <div class="mx-5 my-5">
        <h2 class="text-white text-center">ดาวน์โหลดเอกสาร</h2>
        <div class="flex justify-around mx-20 mt-12">
          <vs-radio v-model="downloadStatus" vs-value="ต้นฉบับ" color="#03a9f3"
            ><p class="text-white">ต้นฉบับ</p></vs-radio
          >
          <vs-radio v-model="downloadStatus" vs-value="สำเนา" color="#03a9f3"
            ><p class="text-white">สำเนา</p></vs-radio
          >
        </div>
        <div class="grid grid-cols-12 gap-4 mt-10">
          <vs-button
            class="col-end-7 col-span-4"
            color="#15c1c3"
            @click="downloadData"
            >ยืนยัน</vs-button
          >
          <vs-button
            class="col-end-11 col-span-4"
            color="#ffffff"
            text-color="#8d9498"
            @click="displayDownload = false"
            >ยกเลิก</vs-button
          >
        </div>
      </div>
    </base-dialog>

    <div class="contentArea">
      <div class="pl-2">
        <div>
          <!-- <topTableButton /> -->
          <!-- <tabComponent /> -->
          <div class="w-full">
            <div class="flex justify-between ml-3 date-filter">
              <div>
                <vs-button
                  v-if="permission.invoice_create"
                  color="#15c1c3"
                  style="width: 180px;"
                  @click="toggleDialog"
                >
                  <font-awesome-icon icon="plus" class="mr-1" />
                  สร้างใบแจ้งหนี้
                </vs-button>
              </div>
              <div class="flex">
                <vs-button
                  class="mr-3 px-px"
                  color="#69d8d1"
                  style="width: 140px;"
                  @click="exportDisplay = true"
                >
                  Export
                </vs-button>
                <vs-button
                  color="#f2a655"
                  class="mr-3 px-px"
                  style="width: 122px;"
                  type="border"
                  @click="filterDisplay = true"
                >
                  <font-awesome-icon
                    icon="filter"
                    class="mr-1"
                    :style="{ color: '#f2a655' }"
                  />
                  Filter by
                </vs-button>
                <!-- <vs-button color="#03a9f3" style="width: 122px;" type="border">
                  <font-awesome-icon
                    icon="search"
                    class="mr-1"
                    :style="{ color: '#03a9f3' }"
                  />
                  Search
                </vs-button> -->
                <div class="search flex items-center">
                  <font-awesome-icon
                    icon="search"
                    class="mr-1"
                    :style="{ color: '#03a9f3' }"
                  />
                  <input
                    type="text"
                    placeholder="Search"
                    v-model="searchTerm"
                  />
                </div>
              </div>
            </div>
            <AgGrid :searchQuery="searchTerm" />
          </div>
        </div>
      </div>
      <download-form ref="downloadInvoice" :type="downloadStatus">
      </download-form>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import baseUrl from "../util/backend.js";
import moment from "moment";
import { mapGetters } from "vuex";
import topTableButton from "../views/elements/topTableButton/topTableButton";
import AgGrid from "./elements/ag-grid-table/AgGridTable";
import AgTable from "../views/elements/ag-grid-table/table_component/tableOnly";
import tabComponent from "./elements/tabComponent/tabComponent";
import boardMain from "./elements/board/boardMain";
import DownloadForm from "./elements/download-form/downloadInvoiceForm";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
export default {
  data() {
    return {
      isLoading: false,
      showDialog: false,
      exportDisplay: false,
      filterDisplay: false,
      displayDelete: false,
      deleteId: null,
      displayDownload: false,
      downloadId: null,
      searchTerm: "",
      accountingList: [],
      bankPaymentList: [],
      memberList: [],
      modalCompany: null,
      selectedAccounting: null,
      // for filtering in modal
      monthSelected: 0,
      yearSelected: new Date().getFullYear(),
      monthList: [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ],
      yearList: [
        "2015",
        "2016",
        "2017",
        "2018",
        "2019",
        "2020",
        "2021",
        "2022",
        "2023",
        "2024",
        "2025",
        "2026",
        "2027",
        "2028",
        "2029",
        "2030",
        "2031",
        "2032",
        "2033",
        "2034",
        "2035",
        "2036",
        "2037",
        "2038",
        "2039",
        "2040",
      ],
      statusList: [
        "รอดำเนินการ",
        "วางบิลแล้ว",
        "ออกใบเสร็จรับเงินแล้ว",
        "แบ่งรับชำระ",
        "ยกเลิก",
      ],
      // for filtering in filter by
      startDate: null,
      endDate: null,
      status: null,
      //for exporting in Export
      exportStartDate: null,
      exportEndDate: null,
      exportStatus: null,
      // for download invoice
      downloadStatus: "ต้นฉบับ",
    };
  },
  computed: {
    ...mapGetters({ nowSlug: "getNowSlug", tabActive: "general/tabActive" }),
    formattedStartDate() {
      if (this.startDate) {
        return moment(this.startDate).format("DD/MM/YYYY");
      } else {
        return null;
      }
    },
    formattedEndDate() {
      if (this.endDate) {
        return moment(this.endDate).format("DD/MM/YYYY");
      } else {
        return null;
      }
    },
    formattedExportStartDate() {
      if (this.exportStartDate) {
        return moment(this.exportStartDate).format("DD/MM/YYYY");
      } else {
        return null;
      }
    },
    formattedExportEndDate() {
      if (this.exportEndDate) {
        return moment(this.exportEndDate).format("DD/MM/YYYY");
      } else {
        return null;
      }
    },
    permission() {
      return this.$store.getters.getPermission;
    },
  },
  components: {
    topTableButton,
    tabComponent,
    boardMain,
    AgGrid,
    AgTable,
    DownloadForm,
    Loading,
  },
  mounted() {
    this.$root.$on("delete-modal", (id) => {
      this.displayDelete = true;
      this.deleteId = id;
    });
    this.$root.$on("update-table", this.loadFilteredTable);
    this.$root.$on("download-invoice", (id) => {
      this.downloadId = id;
      this.showDownload();
    });
    console.log(this.nowSlug);
    // this.$store.dispatch("general/getTab", this.nowSlug);
    console.log("second path", this.tabActive.path);
    this.$store.dispatch(
      "general/getTable",
      this.tabActive.path || this.nowSlug
    );
  },
  beforeDestroy() {
    this.$root.$off("update-table", this.loadFilteredTable);
  },
  watch: {
    // tabActive(newValue) {
    //   this.$store.dispatch("general/getTable", newValue.path);
    // },
    startDate() {
      if (this.endDate) {
        if (this.endDate < this.startDate) {
          this.endDate = this.startDate;
        }
      }
      this.exportStartDate = this.startDate;
    },
    endDate() {
      this.exportEndDate = this.endDate;
    },
    status() {
      this.exportStatus = this.status;
    },
    exportDisplay() {
      if (this.exportDisplay) this.filterDisplay = false;
    },
    filterDisplay() {
      if (this.filterDisplay) this.exportDisplay = false;
    },
  },
  methods: {
    toggleDialog() {
      this.showDialog = !this.showDialog;
    },
    closeExport() {
      this.exportDisplay = false;
    },
    closeFilter() {
      this.filterDisplay = false;
    },
    resetFilter() {
      this.startDate = null;
      this.endDate = null;
      this.status = null;
      this.$store.dispatch("general/getTable", "third");
    },
    async confirmDeleteInvoice() {
      const res = await axios.post(
        `${baseUrl}/invoice/delete?invoice_id=${this.deleteId}`,
        {},
        {
          headers: {
            Authorization: this.$store.getters.getToken,
          },
        }
      );
      console.log(res);
      this.$store.dispatch("general/getTable", "third");
      this.displayDelete = false;
    },
    async loadFilteredMember() {
      if (this.selectedAccounting) {
        const member = await axios.get(
          `${baseUrl}/member/get?accounting_id=${this.selectedAccounting}`,
          {
            headers: {
              Authorization: this.$store.getters.getToken,
            },
          }
        );
        this.memberList = member.data.data;
      } else {
        const member = await axios.get(`${baseUrl}/member/get`, {
          headers: {
            Authorization: this.$store.getters.getToken,
          },
        });
        this.memberList = member.data.data;
      }
    },
    setCompany() {
      this.$store.dispatch("create/setCompanyName", this.modalCompany);
      this.loadSubTable();
    },
    setSelectedTask() {
      this.$store.dispatch(
        "create/setSelectedTask",
        this.$refs.invoiceTable.getSelectedRowData()
      );
      this.$router.push("/createinvoice");
    },
    async loadSubTable() {
      let sendMonth = null;
      if (this.monthSelected < 10) {
        sendMonth = `0${this.monthSelected}`;
      } else {
        sendMonth = this.monthSelected;
      }
      await this.$store.dispatch("general/getSubTable", {
        path: "second",
        month: sendMonth,
        year: this.yearSelected,
      });
    },
    async loadFilteredTable() {
      this.$store.dispatch("general/getFilteredInvoiceTable", {
        path: this.tabActive.path || this.nowSlug,
        startDate:
          this.startDate === null
            ? null
            : moment(this.startDate).format("YYYY-MM-DD"),
        endDate:
          this.endDate === null
            ? null
            : moment(this.endDate).format("YYYY-MM-DD"),
        status: this.status,
      });
    },
    async loadData() {
      const accounting = await axios.get(`${baseUrl}/accounting/get`, {
        headers: {
          Authorization: this.$store.getters.getToken,
        },
      });
      this.accountingList = accounting.data.data;
      const bankPayment = await axios.get(`${baseUrl}/bankpayment/get/`, {
        headers: {
          Authorization: this.$store.getters.getToken,
        },
      });
      this.bankPaymentList = bankPayment.data.data;
      const member = await axios.get(`${baseUrl}/member/get`, {
        headers: {
          Authorization: this.$store.getters.getToken,
        },
      });
      this.memberList = member.data.data;
      this.modalCompany = {
        name: this.memberList[0].company_name,
        id: this.memberList[0].detail_id,
      };
      console.log(this.modalCompany);
      this.setCompany();
    },
    async showDownload() {
      this.displayDownload = true;
    },
    async downloadData() {
      this.isLoading = true;
      await this.$refs.downloadInvoice.generateReport(this.downloadId);
      this.displayDownload = false;
      this.downloadStatus = "ต้นฉบับ";
      this.isLoading = false;
    },
    async exportExcel() {
      if (this.exportStartDate && !this.exportEndDate) {
        alert("Please select End Date");
        return;
      }
      this.isLoading = true;
      const dataPDF = [];
      const response = await axios.get(`${baseUrl}/admin/getTable`, {
        headers: {
          Authorization: this.$store.getters.getToken,
        },
        params: {
          path: this.tabActive.path || this.nowSlug,
          start_date: this.exportStartDate,
          end_date: this.exportEndDate,
          status: this.exportStatus,
        },
      });
      const invoiceData = response.data.data.data;
      console.log(invoiceData);
      if (invoiceData.length === 0) {
        alert("ไม่มีข้อมูล");
        this.isLoading = false;
        return;
      }
      for (const invoice of invoiceData) {
        dataPDF.push({
          A: moment(invoice.date_createdAt).format("DD/MM/YYYY"),
          B: moment(invoice.date).format("DD/MM/YYYY"),
          C: invoice.invoice_code,
          D: invoice.company_code,
          E: invoice.company_name,
          F: invoice.net,
          G: invoice.dropdown,
        });
      }
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const exportToCSV = (apiData, fileName) => {
        const wscols = [
          { wch: 20 },
          { wch: 20 },
          { wch: 25 },
          { wch: 10 },
          { wch: 30 },
          { wch: 20 },
          { wch: 40 },
        ];
        let ws = XLSX.utils.json_to_sheet(apiData);
        ws["!cols"] = wscols;
        ws.A1.v = "วันที่ทำรายการ";
        ws.B1.v = "วันที่เอกสาร";
        ws.C1.v = "เลขที่ใบแจ้งหนี้";
        ws.D1.v = "โค้ดบริษัท";
        ws.E1.v = "ชื่อบริษัท";
        ws.F1.v = "ยอดรวมสุทธิ";
        ws.G1.v = "สถานะ";
        console.log(ws);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
      };
      let fileName = "Invoice";
      if (this.exportStartDate)
        fileName += `_${moment(this.exportStartDate).format("DD-MM-YYYY")}`;

      if (this.exportEndDate)
        fileName += `_${moment(this.exportEndDate).format("DD-MM-YYYY")}`;

      if (this.exportStatus) fileName += `_${this.exportStatus}`;

      exportToCSV(dataPDF, fileName);
      this.exportDisplay = false;
      this.exportStartDate = null;
      this.exportEndDate = null;
      this.exportStatus = null;
      this.isLoading = false;
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style scoped>
.search input[type="text"] {
  font-size: 17px;
  border: none;
  border-radius: 2px;
  background-color: #3a3f51;
  width: 100px;
  color: #dddddd;
  padding: 10px 5px;
  transition: width 0.5s;
}

.search input[type="text"]:focus {
  width: 300px;
}

.search {
  padding-left: 10px;
  border-radius: 5px;
  border: solid 1.5px #03a9f3;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #03a9f3;
  opacity: 1; /* Firefox */
}

h2,
h4 {
  color: #dddddd;
}

select {
  height: 34px;
  border-radius: 2px;
  padding-left: 10px;
  font-size: 17px;
  color: #dddddd;
  background-color: #434f5b;
  border: none;
}

.filter {
  position: absolute;
  right: 0;
  z-index: 1000000;
  background-color: #4e5363;
  width: 20%;
  height: 100vh;
}

.close {
  cursor: pointer;
  margin-top: 8px;
  margin-left: 8px;
  width: 15px;
  height: auto;
}

.filter-header {
  padding: 10px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.09);
}

.filter-input {
  padding: 20px;
}

.filter-input input[type="button"],
.filter-input select {
  display: block;
  height: 34px;
  min-width: 0;
  border-radius: 5px;
  background: #3a3f51;
  border: none;
  color: #ffffff;
  font-size: 17px;
  padding-left: 10px;
}

.right-enter,
.right-leave-to {
  opacity: 0;
  right: -320px;
}

.right-enter-active {
  transition: all 0.3s ease-out;
}

.right-leave-active {
  transition: all 0.3s ease-in;
}

.right-enter-to,
.right-leave {
  opacity: 1;
  right: 0;
}
</style>
